<template>
    <div class="modal fade" id="builder_modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content TopSocialAdCreatives">
                <div class="modal-header padding-x15 padding-y10">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                        <div class="col-4 select-element-name">
                            <h6>Name your element</h6>
                            <div>
                                <input v-model="name" type="text" class="form-control">
                                <div class="invalid-feedback">Element with name {{ name }} already exists.</div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row margin-top20">
                        <div class="col-4 select-data-source">
                            <h6>Select data source</h6>
                            <template v-for="data_source in available_data_sources">
                                <v-select :clearable="false" :value="data_source.name" label="name" :options="data_source.options"></v-select>
                            </template>
                        </div>
                        <template v-for="config in element.element_configurations">
                            <div v-if="config.config_selector_type === 'selectbox' && config.config_short_name == 'select_creative_types'" class="col-5 offset-1 position-relative">
                                <h6>{{ config.config_name }}</h6>
                                <div class="col-5 px-0">
                                    <v-select :clearable="false" :value="configurations[config.config_id] || config.config_values[0]" @input="changeConfig1(config.config_id, $event)" label="name" :options="config.config_values"></v-select>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="row margin-top20">
                        <h6 class="col-12">Select metrics</h6>

                        <div class="col-4">
                            <div class="metrics-list-selections">
                                <input v-model="search_metric" placeholder="Search for a metric..." type="search" class="form-control">

                                <hr class="margin-x0 margin-y10">

                                <div>
                                    <ul class="list-group">
                                        <li v-if="getMetrics.length === 0" class="list-group-item padding-x10 padding-y5">No metrics found.</li>
                                        <template v-if="creative_type == 'TOP IN-FEED'">
                                            <li v-for="metric in getMetrics" @click="selectMetric(metric.id, $event)" class="list-group-item padding-x10 padding-y5" :class="{ 'active': metric.selected, 'hidden': metric.applied === true }" :title="metric.metric_name">{{ metric.new_metric_name || metric.metric_name }} ({{metric.data_source_abbr}})</li>
                                        </template>
                                        <template v-else>
                                            <li v-for="metric in getMetrics" @click="selectMetric(metric.id, $event)" class="list-group-item padding-x10 padding-y5" :class="{ 'active': metric.selected, 'hidden': metric.applied === true }" :title="metric.metric_name">{{ metric.new_metric_name || metric.metric_name }}</li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-1 align-self-center padding-x5">
                            <button @click="applySelectedMetrics" class="btn btn-info">Apply</button>
                        </div>

                        <div class="col-5">
                            <div class="metrics-list-selected">
                                <h6 class="selected-metrics-title">Selected metrics ({{ selected_metrics.length }} of {{ element.max_metrics_visible || 'TBD' }})</h6>

                                <hr class="margin-x0 margin-y10">

                                <div>
                                    <ul class="list-group">
                                        <draggable v-model="selected_metrics" :disabled="metric_sort_disabled" @start="drag=true" @end="drag=false">
                                            <li v-if="selected_metrics.length === 0" class="list-group-item padding-x10 padding-y5">No metrics selected.</li>

                                            <li v-else v-for="metric in selected_metrics" class="list-group-item padding-x10 padding-y5">
                                                <span v-if="!metric.is_editing">
                                                    <span class="metric-name">{{ metric.new_metric_name || metric.metric_name }}</span>
                                                    <i v-if="metric.new_metric_name" class="fa fa-info-circle text-secondary margin-left5" aria-hidden="true" :title="metric.metric_name"></i>
                                                </span>
                                                <input v-else @keyup.enter="saveAppliedMetricName(metric.id, $event)" type="text" class="form-control metric-edit" :value="metric.new_metric_name || metric.metric_name">
                                                <i v-if="!metric.is_editing" @click="removeAppliedMetric(metric.id)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                <i v-if="!metric.is_editing" @click="editAppliedMetricName(metric.id, $event)" class="fa fa-pencil pull-right text-info margin-left10" aria-hidden="true"></i>
                                                <i v-if="metric.is_editing" @click="cancelAppliedMetricName(metric.id, $event)" class="fa fa-times pull-right text-danger margin-left10" aria-hidden="true"></i>
                                                <i v-if="metric.is_editing" @click="saveAppliedMetricName(metric.id, $event)" class="fa fa-check pull-right text-success margin-left10" aria-hidden="true"></i>
                                                <i class="fa fa-sort pull-right margin-left10" aria-hidden="true"></i>
                                                <span class="pull-right">({{ metric.data_source_abbr }})</span>
                                            </li>
                                        </draggable>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <div class="row">
                        <div class="col-12">
                            <div v-for="config in element.element_configurations" class="margin-bottom10">
                                <template v-if="config.config_selector_type === 'checkbox'">
                                    <label>
                                        <p-input v-model="configurations[config.config_id]" @change="changeConfig(config.config_id, $event)" class="p-default p-curve single" type="checkbox" :value="config.config_id"> {{ config.config_name }}</p-input>
                                    </label>
                                </template>

                                <template v-if="config.config_selector_type === 'selectbox' && config.config_short_name != 'select_creative_types'">
                                    <h6>{{ config.config_name }}</h6>
                                    <div class="col-3 px-0">
                                        <v-select :clearable="false" :value="configurations[config.config_id] || config.config_values[0]" @input="changeConfig(config.config_id, $event)" label="name" :options="config.config_values"></v-select>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer padding-y10">
                    <button :disabled="build_disabled" @click="buildElement" type="button" class="btn btn-success">{{ edit_mode ? 'Update' : 'Build' }} Element</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.element              = this.$store.getters.getBuilderPopupParams.element;
            this.edit_mode            = this.$store.getters.getBuilderPopupParams.edit_mode || false;

            Object.assign(this.$data, vm.customClone(this.$store.getters.getBuilderPopupParams.data || {}));

            _.each(this.element.element_configurations, (config) => {
                if(!this.configurations[config.config_id]){
                    this.configurations[config.config_id] = config.config_values[0];
                }
                if(config.config_short_name == 'select_data_sources'){
                    this.ds_config_id = config.config_id;
                }
                if(config.config_short_name == 'select_creative_types'){
                    this.creative_type = this.configurations[config.config_id];
                    this.top_social_config_id = config.config_id;
                }
            });


            this.all_data_sources = this.$store.getters.getBuilderPopupParams.data_sources;
            let index = 0;
            if(this.creative_type == 'AD CREATIVES'){
                index = _.findIndex(this.all_data_sources, {abbreviation: 'fba'});
                if(index == -1){
                    index = _.findIndex(this.all_data_sources, {abbreviation: 'linkedin'});
                }
            }
            if(this.creative_type == 'TOP STORIES'){
                index = _.findIndex(this.all_data_sources, {abbreviation: 'inst'});
            }
            if(this.creative_type == 'TOP IN-FEED'){
                index = _.findIndex(this.all_data_sources, {name: 'Facebook/Instagram Top In Feed'});
            }
            if(this.creative_type == 'PROMOTED POSTS'){
                index = _.findIndex(this.all_data_sources, {abbreviation: 'fba'});
            }

            this.available_data_sources.push(this.all_data_sources[index]);
            this.available_data_sources[0].options = [this.all_data_sources[index].name];
            this.selected_data_source = this.$store.getters.getBuilderPopupParams.data_sources[index].id;
            this.data_sources_by_creative_type['AD CREATIVES'] = _.findIndex(this.all_data_sources, {abbreviation: 'fba'});
            this.data_sources_by_creative_type['TOP STORIES'] = _.findIndex(this.all_data_sources, {abbreviation: 'inst'});
            this.data_sources_by_creative_type['TOP IN-FEED'] = _.findIndex(this.all_data_sources, {name: 'Facebook/Instagram Top In Feed'});
            this.data_sources_by_creative_type['PROMOTED POSTS'] = _.findIndex(this.all_data_sources, {abbreviation: 'fba'});

            this.validate();
        },

        data() {
            return {
                name:                   '',
                original_name:          '',
                selected_data_source:   '',
                search_metric:          '',
                element:                {},
                metrics:                [],
                all_data_sources:       null,
                available_data_sources: [],
                selected_metrics:       [],
                configurations:         {},
                build_disabled:         true,
                edit_mode:              false,
                metric_sort_disabled:   false,
                ds_config_id:           0,
                ds_config_name:         '',
                ds_config_backup:       null,
                top_social_config_id:   0,
                creative_type:       '',
                data_sources_by_creative_type: {}
            }
        },

        methods: {
            selectMetric(metricId, event) {
                const index = _.findIndex(this.metrics, {id: metricId});

                this.metrics[index].selected = !$(event.target).hasClass('active');
            },

            applySelectedMetrics() {
                if ((this.selected_metrics.length + _.filter(this.metrics, {selected: true}).length) > this.element.max_metrics_visible) {
                    this.$notify({
                        type: 'error',
                        text: `The maximum metrics for this is ${this.element.max_metrics_visible}. Please remove one of the current metrics if you want to add a replacement.`
                    });

                    return false;
                }

                _.each(this.metrics, metric => {
                    if (metric.selected && _.findIndex(this.selected_metrics, {id: metric.id}) === -1) {
                        metric.applied  = true;
                        metric.selected = false;

                        this.selected_metrics.push(metric);
                    }
                });

                this.validate();
            },

            editAppliedMetricName(metricId, event) {
                let index = _.findIndex(this.selected_metrics, {id: metricId});

                if (index > -1) {
                    this.selected_metrics[index].is_editing = true;
                }

                this.metric_sort_disabled = true;

                this.$forceUpdate();
                this.$nextTick(() => {
                    $(event.target).closest('li').find('.metric-edit').select();
                });
            },

            cancelAppliedMetricName(metricId, event) {
                let index = _.findIndex(this.selected_metrics, {id: metricId});

                if (index > -1) {
                    this.selected_metrics[index].is_editing = false;
                }

                this.metric_sort_disabled = false;

                this.$forceUpdate();
                this.$nextTick(() => {
                    $(event.target).closest('li').find('.metric-edit').select();
                });
            },

            saveAppliedMetricName(metricId, event) {
                let index = _.findIndex(this.selected_metrics, {id: metricId});

                if (index > -1) {
                    this.selected_metrics[index].is_editing      = false;
                    this.selected_metrics[index].new_metric_name = $(event.target).closest('li').find('.metric-edit').val().trim();

                    let formData = new FormData;
                    formData.append('metric_id', this.selected_metrics[index].metric_id);
                    formData.append('new_metric_name', this.selected_metrics[index].new_metric_name);
                    formData.append('_method', 'PUT');

                    if (this.selected_metrics[index].client_x_metric_x_data_source_id) {
                        formData.append('client_x_metric_x_data_source_id', this.selected_metrics[index].client_x_metric_x_data_source_id);
                    } else {
                        formData.append('data_source_ids', JSON.stringify([this.selected_metrics[index].data_source_id]));
                    }

                    this.ajaxSubmit({}, 'POST', `/api/metrics/client/${this.$store.getters.getBuilderPopupParams.client_id}/glossary`, formData).then(response => {
                        const queryString = $.param({
                            data_source_id: this.selected_data_source,
                            client_id:      this.$store.getters.getBuilderPopupParams.client_id,
                            element_id:     this.element.id
                        });

                        axios.get(`/api/metrics?${queryString}`).then(metrics => {
                            let renamedMetrics = _.filter(metrics.data, metric => {
                                return metric.client_x_metric_x_data_source_id !== null;
                            });

                            _.each(renamedMetrics, metric => {
                                let renamedMetricIndex = _.findIndex(this.metrics, {id: metric.id});

                                if (renamedMetricIndex > -1) {
                                    this.metrics[renamedMetricIndex].new_metric_name                  = metric.new_metric_name;
                                    this.metrics[renamedMetricIndex].client_x_metric_x_data_source_id = metric.client_x_metric_x_data_source_id;
                                }

                                renamedMetricIndex = _.findIndex(this.selected_metrics, {id: metric.id});

                                if (renamedMetricIndex > -1) {
                                    this.selected_metrics[renamedMetricIndex].new_metric_name                  = metric.new_metric_name;
                                    this.selected_metrics[renamedMetricIndex].client_x_metric_x_data_source_id = metric.client_x_metric_x_data_source_id;
                                }
                            });
                        });
                    });
                }

                this.metric_sort_disabled = false;

                this.$forceUpdate();
            },

            removeAppliedMetric(metricId) {
                let index = _.findIndex(this.selected_metrics, {id: metricId});
                this.selected_metrics.splice(index, 1);

                index = _.findIndex(this.metrics, {id: metricId});
                if (index > -1) {
                    this.metrics[index].applied = false;
                }

                this.validate();
            },

            removeAllAppliedMetrics(){
                const selected_metrics = [...this.selected_metrics];
                _.each(selected_metrics, (metric, idx) => {
                    let index = 0;
                    index = _.findIndex(this.selected_metrics, {id: metric.metric_id});
                    this.selected_metrics.splice(index, 1);
                    index = _.findIndex(this.metrics, {id: metric.metric_id});
                    if (index > -1) {
                        this.metrics[index].applied = false;
                    }
                });

                this.validate();
            },

            buildElement() {
                if (!this.edit_mode) {
                    this.$store.commit('addBuilderElement', {
                        name:                 this.name || this.$parent.generateElementName(),
                        element_id:           this.element.id,
                        element_abbreviation: this.element.abbreviation,
                        metrics:              this.selected_metrics,
                        configurations:       this.configurations
                    });
                } else {
                    this.$store.commit('updateBuilderElement', {
                        data: {
                            name:                 this.name || this.$parent.generateElementName(),
                            element_id:           this.element.id,
                            element_abbreviation: this.element.abbreviation,
                            metrics:              this.selected_metrics,
                            configurations:       this.configurations
                        },

                        name: this.$store.getters.getBuilderPopupParams.data.original_name
                    });
                }

                event_bus.$emit('element_saved', true);

                $('#builder_modal').modal('hide');
            },

            changeConfig(configId, value) {
                if (typeof value === 'boolean') {
                    if (value === true) {
                        this.configurations[configId] = 'true';
                    } else {
                        delete this.configurations[configId];
                    }
                } else {
                    this.configurations[configId] = value;
                    if((configId == this.ds_config_id) && (value != 'Instagram') && this.creative_type == 'TOP STORIES'){
                        this.configurations[this.top_social_config_id] = 'AD CREATIVES';
                        this.creative_type = 'AD CREATIVES';

                        const index = this.data_sources_by_creative_type[this.creative_type];

                        this.available_data_sources[0] = this.all_data_sources[index];
                        this.available_data_sources[0].options = [this.all_data_sources[index].name];
                        this.selected_data_source = this.all_data_sources[index].id;
                        this.removeAllAppliedMetrics();
                    }
                    if((configId == this.ds_config_id) && this.creative_type == 'TOP IN-FEED'){
                        if (this.selected_data_source) {
                            const queryString = $.param({
                                data_source_id: this.selected_data_source,
                                client_id:      this.$store.getters.getBuilderPopupParams.client_id,
                                element_id:     this.element.id,
                                creative_type:  this.creative_type,
                                ds_selected:    this.configurations[this.ds_config_id]
                            });

                            axios.get(`/api/metrics?${queryString}`).then(metrics => {
                                _.each(metrics.data, metric => {
                                    metric.selected = false;
                                    metric.applied  = _.findIndex(this.selected_metrics, {id: metric.id}) > -1;
                                });

                                this.metrics = metrics.data;
                            });
                            this.removeAllAppliedMetrics();
                        }
                    }
                }

                this.$forceUpdate();
            },
            changeConfig1(configId, value) {
                let selected_data_source_changed;
                let creative_type_changed;
                this.configurations[configId] = value;
                if(value == 'TOP STORIES' && this.ds_config_id){
                    this.ds_config_backup = this.configurations[this.ds_config_id];
                    this.configurations[this.ds_config_id] = 'Instagram';
                }
                else if(this.ds_config_backup && this.ds_config_id){
                    this.configurations[this.ds_config_id] = this.ds_config_backup;
                }

                creative_type_changed = this.creative_type != value;
                this.creative_type = value;

                const index = this.data_sources_by_creative_type[value];

                this.available_data_sources[0] = this.all_data_sources[index];
                this.available_data_sources[0].options = [this.all_data_sources[index].name];

                selected_data_source_changed = this.selected_data_source != this.all_data_sources[index].id;
                this.selected_data_source = this.all_data_sources[index].id;

                if(creative_type_changed && !selected_data_source_changed){
                    this.updateMetrics();
                }
                this.removeAllAppliedMetrics();
                this.$forceUpdate();
            },
            validate() {
                this.build_disabled = true;

                if (
                    (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    )
                    && this.element.max_metrics_visible >= this.selected_metrics.length
                    && this.element.min_metrics_visible <= this.selected_metrics.length
                ) {
                    this.build_disabled = false;
                }
            },
            updateMetrics(){
                const queryString = $.param({
                    data_source_id: this.selected_data_source,
                    client_id:      this.$store.getters.getBuilderPopupParams.client_id,
                    element_id:     this.element.id,
                    creative_type:  this.creative_type,
                    ds_selected:    this.configurations[this.ds_config_id]
                });

                axios.get(`/api/metrics?${queryString}`).then(metrics => {
                    _.each(metrics.data, metric => {
                        metric.selected = false;
                        metric.applied  = _.findIndex(this.selected_metrics, {id: metric.id}) > -1;
                    });

                    this.metrics = metrics.data;
                });
            }
        },

        watch: {
            selected_data_source() {
                let linkedin_id;
                let config_id;
                _.each(this.available_data_sources, data_source => {
                    if(data_source.abbreviation == 'linkedin'){
                        linkedin_id = data_source.id;
                    }
                });
                _.each(this.element.element_configurations, configuration => {
                    if(configuration.config_short_name == 'select_data_sources'){
                        config_id = configuration.config_id;
                    }
                });
                if (this.selected_data_source) {
                    if(this.selected_data_source == linkedin_id){
                        this.changeConfig(config_id, 'Linkedin')
                    }

                    const queryString = $.param({
                        data_source_id: this.selected_data_source,
                        client_id:      this.$store.getters.getBuilderPopupParams.client_id,
                        element_id:     this.element.id,
                        creative_type:  this.creative_type,
                        ds_selected:    this.configurations[this.ds_config_id]
                    });

                    axios.get(`/api/metrics?${queryString}`).then(metrics => {
                        _.each(metrics.data, metric => {
                            metric.selected = false;
                            metric.applied  = _.findIndex(this.selected_metrics, {id: metric.id}) > -1;
                        });

                        this.metrics = metrics.data;
                    });
                }
            },

            name() {
                if (this.name) {
                    if (
                        _.findIndex(this.$store.getters.getBuilderElements, {name: this.name}) === -1
                        || (this.edit_mode && this.$store.getters.getBuilderPopupParams.data.name === this.name)
                    ) {
                        $('#builder_modal').find('.select-element-name input').removeClass('is-invalid');
                    } else {
                        $('#builder_modal').find('.select-element-name input').addClass('is-invalid');
                    }
                }

                this.validate();
            }
        },

        computed: {
            getMetrics() {
                return this.metrics.filter(metric => {
                    let metricName = metric.new_metric_name || metric.metric_name;

                    return metricName.toLowerCase().indexOf(this.search_metric.toLowerCase()) > -1;
                });
            }
        }
    }
</script>
